import React, { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ButtonIcon, getStyles } from './ActionButton';
export default function ActionLink({ to, variant, className, Icon, children, onClick, }) {
    const styles = getStyles();
    const [hover, setHover] = useState(false);
    return (React.createElement(Link, { onMouseLeave: () => setHover(prev => !prev), onMouseEnter: () => setHover(prev => !prev), to: to, className: classNames(styles.root, styles[variant], className), onClick: onClick },
        Icon && (React.createElement(ButtonIcon, { Icon: Icon, hover: hover, variant: variant, className: styles.icon })),
        children));
}
//# sourceMappingURL=ActionLink.js.map